import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import Typography from '@latitude/typography';

const StandaloneTextBody = ({ text, style }) => {
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => {
        switch (style) {
          case 'Subtitle':
            return <Typography.Body>{children}</Typography.Body>;

          case 'Legal':
            return <Typography.Caption>{children}</Typography.Caption>;

          default:
            return <Typography.Body>{children}</Typography.Body>;
        }
      }
    }
  };

  return documentToReactComponents(text, options);
};

export default StandaloneTextBody;
